import React, { useState, useEffect } from "react";
import { Input, DatePicker, Spin } from "antd";
import Pagination from "../../../components/global/pagination/Pagination.jsx";
import columns from "../../../columns/wallet/Deposit.js";
import TableWithSkeleton from "../../../components/global/table/TableWithSkeleton.jsx";
import { GetAllwalletDepositApi } from "../../../api/request/wallet/deposit.js";
import moment from "moment";
import ExportHandler from "../../../components/global/export/ExportHandler.jsx";
import Eye from "../../../assets/Eye.jsx";
import ModalComponent from "../../../components/global/modal/ModalComponent.jsx";
import useModulePermissions from "../../../hooks/useModulePermissions.jsx";

const { RangePicker } = DatePicker;

export default function Deposit() {
  const depositPermissions = useModulePermissions("wallet", "deposit");
  const canExport = !!depositPermissions.export;
  const [pageSize, setPageSize] = useState(10);
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [searchText, setSearchText] = useState("");
  const [totalRecord, setTotalRecord] = useState(0);
  const [search, setSearch] = useState("");
  const [dates, setDates] = useState([]);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [depositDetails, setDepositDetails] = useState({});

  const getAllDeposit = async () => {
    try {
      let params = {
        PageNumber: page,
        PageSize: pageSize,
        SearchText: searchText,
        FromDate: dates.length === 2 ? dates[0].format("MM-DD-YYYY") : "",
        ToDate: dates.length === 2 ? dates[1].format("MM-DD-YYYY") : "",
      };
      setIsLoading(true);
      const { data } = await GetAllwalletDepositApi(
        new URLSearchParams(params).toString(),
      );
      if (data?.success) {
        setData(
          data.data?.map((item) => {
            return {
              ...item,
              createdDate: moment(item?.createdDate).format(
                "DD-MM-YYYY, hh:mm A",
              ),
              amount: `$ ${item?.amount}`,
              status:
                item?.status == "Success" ? (
                  <span className="px-3 py-1 rounded-full uppercase text-xs text-center success_tag">
                    {item?.status}
                  </span>
                ) : (
                  <span className="uppercase px-3 py-1 rounded-full text-xs text-center fail_tag">
                    {item?.status}
                  </span>
                ),
              action: (
                <div className="flex justify-center items-center gap-2">
                  <button
                    type="button"
                    onClick={() => {
                      setDepositDetails(item);
                      setIsOpenModal(true);
                    }}
                  >
                    <Eye />
                  </button>
                </div>
              ),
            };
          }),
        );
        setTotalRecord(data?.totalRecords);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getAllDeposit();
  }, [page, pageSize, dates, searchText]);

  useEffect(() => {
    setPage(1);
  }, [searchText]);

  const exportHandler = async () => {
    try {
      let params = {
        ApplyPagination: false,
        SearchText: searchText,
        FromDate: dates.length === 2 ? dates[0].format("MM-DD-YYYY") : "",
        ToDate: dates.length === 2 ? dates[1].format("MM-DD-YYYY") : "",
      };
      const { data } = await GetAllwalletDepositApi(
        new URLSearchParams(params).toString(),
      );
      if (data?.success) {
        return {
          data: data?.data,
          removableColumns: ["userId"],
          fileName: "Deposit List",
        };
      } else {
        return { data: [], removableColumns: [] };
      }
    } catch (error) {
      return { data: [], removableColumns: [] };
    }
  };

  return (
    <div>
      <div className="flex justify-end flex-wrap gap-5">
        <div className="flex flex-wrap items-center gap-3">
          <RangePicker
            className="py-1.5 rounded-lg"
            format="DD-MM-YYYY"
            onChange={(dates) => setDates(dates || [])}
          />
          <div>
            <Input
              size="large"
              style={{ width: 220 }}
              placeholder="Search"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              onPressEnter={() => setSearchText(search)}
              prefix={
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  class="w-5 h-5"
                >
                  <path
                    fill-rule="evenodd"
                    d="M10.5 3.75a6.75 6.75 0 1 0 0 13.5 6.75 6.75 0 0 0 0-13.5ZM2.25 10.5a8.25 8.25 0 1 1 14.59 5.28l4.69 4.69a.75.75 0 1 1-1.06 1.06l-4.69-4.69A8.25 8.25 0 0 1 2.25 10.5Z"
                    clip-rule="evenodd"
                  />
                </svg>
              }
              suffix={
                search && (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    onClick={() => {
                      setSearchText("");
                      setSearch("");
                    }}
                    viewBox="0 0 24 24"
                    fill="#bebebe"
                    className="size-5 cursor-pointer duration-300 hover:fill-[#969595]"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm-1.72 6.97a.75.75 0 1 0-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 1 0 1.06 1.06L12 13.06l1.72 1.72a.75.75 0 1 0 1.06-1.06L13.06 12l1.72-1.72a.75.75 0 1 0-1.06-1.06L12 10.94l-1.72-1.72Z"
                      clip-rule="evenodd"
                    />
                  </svg>
                )
              }
            />
          </div>
          {canExport && (
            <div>
              <ExportHandler exportHandler={exportHandler} />
            </div>
          )}
        </div>
      </div>

      <div className="my-6">
        <div className="border border-gray-200 rounded-xl overflow-hidden bg-white">
          <TableWithSkeleton
            columns={columns}
            data={data}
            loading={isLoading}
            page={page}
            pageSize={pageSize}
            index={true}
          />
        </div>
        <Pagination
          total={totalRecord}
          pageSize={pageSize}
          setPageSize={setPageSize}
          page={page}
          setPage={setPage}
        />
      </div>

      <ModalComponent
        isOpen={isOpenModal}
        setIsOpen={setIsOpenModal}
        title="Deposit Information"
        width={1500}
      >
        <div className="p-5">
          <div className="grid lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 gap-10">
            {depositDetails?.firstName ? (
              <div>
                <p className="text-description font-normal">First Name</p>
                <p className="text-description primary font-semibold mt-2">
                  {depositDetails?.firstName || "---"}
                </p>
              </div>
            ) : (
              ""
            )}
            {depositDetails?.lastName ? (
              <div>
                <p className="text-description font-normal">Last Name</p>
                <p className="text-description primary font-semibold mt-2">
                  {depositDetails?.lastName || "---"}
                </p>
              </div>
            ) : (
              ""
            )}
            {depositDetails?.transactionId ? (
              <div>
                <p className="text-description font-normal">Transaction Id</p>
                <p className="text-description primary font-semibold mt-2">
                  {depositDetails?.transactionId || "---"}
                </p>
              </div>
            ) : (
              ""
            )}
            {depositDetails?.paymentgateway ? (
              <div>
                <p className="text-description font-normal">Payment Gateway</p>
                <p className="text-description primary font-semibold mt-2">
                  {depositDetails?.paymentgateway || "---"}
                </p>
              </div>
            ) : (
              ""
            )}
            {depositDetails?.from ? (
              <div>
                <p className="text-description font-normal">From</p>
                <p className="text-description primary font-semibold mt-2">
                  {depositDetails?.from || "---"}
                </p>
              </div>
            ) : (
              ""
            )}
            {depositDetails?.to ? (
              <div>
                <p className="text-description font-normal">To</p>
                <p className="text-description primary font-semibold mt-2">
                  {depositDetails?.to || "---"}
                </p>
              </div>
            ) : (
              ""
            )}
            {depositDetails?.type ? (
              <div>
                <p className="text-description font-normal">Type</p>
                <p className="text-description primary font-semibold mt-2">
                  {depositDetails?.type || "---"}
                </p>
              </div>
            ) : (
              ""
            )}
            {depositDetails?.amount ? (
              <div>
                <p className="text-description font-normal">Amount</p>
                <p className="text-description primary font-semibold mt-2">
                  {typeof depositDetails?.amount === "string"
                    ? depositDetails?.amount
                    : `$ ${depositDetails?.amount}`}
                </p>
              </div>
            ) : (
              ""
            )}
            {depositDetails?.fee !== undefined ? (
              <div>
                <p className="text-description font-normal">Fee</p>
                <p className="text-description primary font-semibold mt-2">
                  $ {depositDetails?.fee || 0}
                </p>
              </div>
            ) : (
              ""
            )}
            {depositDetails?.requestedAmount !== undefined ? (
              <div>
                <p className="text-description font-normal">Requested Amount</p>
                <p className="text-description primary font-semibold mt-2">
                  $ {depositDetails?.requestedAmount || 0}
                </p>
              </div>
            ) : (
              ""
            )}
            {depositDetails?.commission ? (
              <div>
                <p className="text-description font-normal">Commission</p>
                <p className="text-description primary font-semibold mt-2">
                  {depositDetails?.commission || "---"}
                </p>
              </div>
            ) : (
              ""
            )}
            {depositDetails?.walletAccountNo ? (
              <div>
                <p className="text-description font-normal">
                  Wallet Account No.
                </p>
                <p className="text-description primary font-semibold mt-2">
                  {depositDetails?.walletAccountNo || "---"}
                </p>
              </div>
            ) : (
              ""
            )}

            {depositDetails?.createdDate ? (
              <div>
                <p className="text-description font-normal">Created Time</p>
                <p className="text-description primary font-semibold mt-2">
                  {depositDetails?.createdDate || "---"}
                </p>
              </div>
            ) : (
              ""
            )}
            {depositDetails?.status ? (
              <div>
                <p className="text-description font-normal">Status</p>
                <p className="text-description primary font-semibold mt-2">
                  {depositDetails?.status || "---"}
                </p>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
      </ModalComponent>
    </div>
  );
}
